const Role = {
  PortalAdmin: "portal-admin",
  Accounting: "accounting",
  SalesPartnerships: "sales-and-partnership",
  DataAnalyst: "data-analyst",
};

export default Role;
